import {UyapRequest} from "./UyapRequest";
import app from "@/main";

export interface BorcluTasinmazTakyidatSorgulamaTalep {
    dosyaId: string,
    kisiKurumId: number,
    tasinmazId: number,
    hisseId: number,
    dosyaHash?: string
}

export interface BorcluTasinmazTakyidatSorgulamaCevap {
    serhList: SerhList[]
    sonuc: boolean
    id: string
    isCompressed: boolean
    htmlHataKodList: any[]
    isMock: boolean,
    message: string
}

export interface SerhList {
    serhBeyanId: number
    serhBeyanTip: string
    sablon: string
    tapuBolumDurum: string
    cumle: string
    baslamaTarih: string
    bitisTarih: string
    sure: number
    ilkTesisIslem: IlkTesisIslem
    tapuBolumSerhBeyanId: number
    tesisIslem: TesisIslem
    terkinIslem: TerkinIslem
    lehtarlar: any[]
    tapuBolum: string
    tapuBolumReferans: number
    ustSerhBeyanlar: any[]
    secildi: boolean
}

export interface IlkTesisIslem {
    islemId: number
    islemDurum: string
}

export interface TesisIslem {
    islemId: number
    islemTanimAd: string
    baslamaSekilAd: string
    yevmiye: Yevmiye
    islemDurum: string
}

export interface Yevmiye {
    yevmiyeId: number
    kurum: string
    kurumid: string
    tarih: string
    yevmiyeNo: number
}

export interface TerkinIslem {
    islemId: number
    islemDurum: string
}


export default class BorcluTasinmazTakyidatSorgulama extends UyapRequest<BorcluTasinmazTakyidatSorgulamaTalep, BorcluTasinmazTakyidatSorgulamaCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Borçlu taşınmaz takyidat sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "BorcluTasinmazTakyidatSorgulama_" + app.$uyapHelper.hashTalepForCache(this.talepData)
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + "borclu_bilgileri_goruntule_tasinmaz_takyidat_brd.ajx";
    }

    getMockResponse(): any {
        return {"serhList":[{"serhBeyanId":229839343,"serhBeyanTip":"Serh","sablon":"İcrai Haciz","tapuBolumDurum":"Aktif","cumle":"İcrai Haciz :     Konya 3. İcra Dairesi nin 05/10/2021 tarih 2019/10360 sayılı Haciz Yazısı sayılı yazıları ile     6610.36   TL bedel ile Alacaklı :   Denizbank Anonim Şirketi lehine haciz işlenmiştir.","baslamaTarih":"05/10/2021","bitisTarih":"05/10/2021","sure":0,"ilkTesisIslem":{"islemId":0,"islemDurum":"BELIRSIZ"},"tapuBolumSerhBeyanId":498396590,"tesisIslem":{"islemId":198294531,"islemTanimAd":"İcrai Haciz Tesisi","baslamaSekilAd":"Web Başvurusu İle","yevmiye":{"yevmiyeId":138095229,"kurum":"Çumra","kurumid":"308","tarih":"2021-10-05T16:16:37.187","yevmiyeNo":18364},"islemDurum":"ISLEM_TAMAMLANDI"},"terkinIslem":{"islemId":0,"islemDurum":"BELIRSIZ"},"lehtarlar":[],"tapuBolum":"ZeminHisse","tapuBolumReferans":399163955,"ustSerhBeyanlar":[],"secildi":false},{"serhBeyanId":243450226,"serhBeyanTip":"Serh","sablon":"Kamu Haczi","tapuBolumDurum":"Aktif","cumle":"Kamu Haczi :     001255 ÇUKUROVA Vergi Dairesi nin 24/01/2022 tarih 15114 sayılı Haciz Yazısı sayılı yazıları ile. Borç :    4626.0   TL (Alacaklı :   001255 ÇUKUROVA Vergi Dairesi )","baslamaTarih":"25/01/2022","bitisTarih":"25/01/2022","sure":0,"ilkTesisIslem":{"islemId":0,"islemDurum":"BELIRSIZ"},"tapuBolumSerhBeyanId":530017411,"tesisIslem":{"islemId":205816992,"islemTanimAd":"Kamu Haczinin Tesisi","baslamaSekilAd":"Web Başvurusu İle","yevmiye":{"yevmiyeId":143729515,"kurum":"Çumra","kurumid":"308","tarih":"2022-01-25T09:11:43.207","yevmiyeNo":2043},"islemDurum":"ISLEM_TAMAMLANDI"},"terkinIslem":{"islemId":0,"islemDurum":"BELIRSIZ"},"lehtarlar":[],"tapuBolum":"ZeminHisse","tapuBolumReferans":399163955,"ustSerhBeyanlar":[],"secildi":false}],"sonuc":false,"id":"1254752331513200072644424646107415643014507","isCompressed":false,"htmlHataKodList":[],"isMock":false};
    }

    async parse(data: BorcluTasinmazTakyidatSorgulamaCevap): Promise<BorcluTasinmazTakyidatSorgulamaCevap> {
        data.message = "Takyidat bilgisi bulundu"
        return data;
    }
}

